if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this._loading = false;
      this._attrObserver = null;
    }

    connectedCallback() {
      this._observeDataUrl();
      this.performRecommendations();
    }

    _observeDataUrl() {
      if (this._attrObserver && this._attrObserver.disconnect) {
        this._attrObserver.disconnect();
      }
      this._attrObserver = new MutationObserver(mutations => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'data-url') {
            this.performRecommendations(true);
          }
        }
      });
      this._attrObserver.observe(this, { attributes: true, attributeFilter: ['data-url'] });
    }

    async performRecommendations(force = false) {
      const container = this.querySelector('[data-recommendations]');
      const url = this.dataset.url;
      
      if (!container || !url || this._loading) return;

      this._loading = true;

      //console.log('Fetching product recommendations from:', url);
      
      try {
        const response = await fetch(url);
        
        // ✅ FIX: Controlla se la response è OK
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const text = await response.text();
        
        // ✅ FIX: Controlla se il testo è vuoto
        if (!text || text.trim() === '') {
          //console.log('Empty response from recommendations API');
          return;
        }
        
        // ✅ FIX: Parser sicuro con try/catch
        let html;
        try {
          html = new DOMParser().parseFromString(text, 'text/html');
        } catch (parseError) {
          console.error('Failed to parse HTML response:', parseError);
          //console.log('Response text:', text.substring(0, 200) + '...');
          return;
        }
        
        // ✅ FIX: Controllo esistenza elemento prima di accedere
        const recommendationsElement = html.querySelector('[data-recommendations]');
        if (!recommendationsElement) {
          //console.log('No [data-recommendations] element found in response');
          //console.log('Response HTML structure:', html.body?.innerHTML?.substring(0, 200) + '...');
          return;
        }
        
        const recommendationsHTML = recommendationsElement.innerHTML?.trim();
        
        // ✅ FIX: Doppio controllo del contenuto
        if (!recommendationsHTML || recommendationsHTML === '') {
          //console.log('Recommendations element is empty');
          return;
        }

        // ✅ Solo se tutto va bene, aggiorna il DOM
        container.innerHTML = recommendationsHTML;

        // ✅ FIX: Attendere un frame prima di inizializzare Swiper
        await new Promise(resolve => requestAnimationFrame(resolve));
        
        this._initSliderSafely();

        // ✅ FIX: Quick cart initialization sicura
        setTimeout(() => {
          try {
            const quickCart = document.querySelector('quick-cart-drawer');
            if (quickCart && typeof quickCart.init === 'function') {
              quickCart.init();
            } else {
              this.querySelectorAll('.quick-cart-drawer__trigger').forEach(el => {
                try {
                  el.remove();
                } catch (removeError) {
                  // Ignora errori di rimozione
                }
              });
            }
          } catch (quickCartError) {
            console.error('Quick cart initialization failed:', quickCartError);
          }
        }, 100);

        // ✅ Mostra solo se tutto è andato bene
        this.classList.remove('hidden');
        //console.log('Product recommendations loaded successfully');
        
      } catch (error) {
        console.error('Product recommendations failed:', error);
        console.error('URL:', url);
        
        // ✅ FIX: In caso di errore, nascondi il componente
        this.classList.add('hidden');
      } finally {
        this._loading = false;
      }
    }

    _initSliderSafely() {
      // ✅ FIX: Cleanup slider precedente
      if (this.slider) {
        try {
          if (typeof this.slider.destroy === 'function') {
            this.slider.destroy(true, true);
          }
        } catch (destroyError) {
          console.warn('Slider destroy failed:', destroyError);
        }
        this.slider = null;
      }
      
      const el = this.querySelector('.swiper');
      if (!el) {
        //console.log('No .swiper element found for slider initialization');
        return;
      }

      const tryInit = (attempt = 0) => {
        try {
          if (window.Swiper) {
            this.slider = new Swiper(el, { 
              slidesPerView: 'auto', 
              spaceBetween: 16,
              observer: true,
              observeParents: true,
              watchOverflow: true,
              // ✅ FIX: Previeni errori se non ci sono slide
              on: {
                init: function() {
                  //console.log('Recommendations slider initialized');
                }
              }
            });
          } else if (attempt < 20) { // ✅ FIX: Aumentato tentativi
            setTimeout(() => tryInit(attempt + 1), 50);
          } else {
            console.warn('Swiper library not available after 20 attempts');
          }
        } catch (swiperError) {
          console.error('Swiper initialization error:', swiperError);
        }
      };
      
      tryInit();
    }

    // ✅ FIX: Cleanup quando componente viene rimosso
    disconnectedCallback() {
      if (this._attrObserver) {
        this._attrObserver.disconnect();
        this._attrObserver = null;
      }
      
      if (this.slider) {
        try {
          this.slider.destroy();
        } catch (e) {
          // Ignora errori di cleanup
        }
        this.slider = null;
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}